import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

const codeParamName = 'redirectCode';
const redirectCode = '3948';

const useTargetNavigationRedirect = () => {
  const location = useLocation();
  const [targetNavigationRedirectUrl, setTargetNavigationRedirectUrl] =
    useState<string | undefined>();

  useEffect(() => {
    const urlParameter = new URLSearchParams(location.search);
    const codeParam = urlParameter.get(codeParamName) ?? undefined;

    if (codeParam === redirectCode) {
      setTargetNavigationRedirectUrl(
        `${import.meta.env.VITE_BASE_URL}${location.pathname}`
      );

      /** Clear code parameter from url */
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  return targetNavigationRedirectUrl;
};

export default useTargetNavigationRedirect;
